import React from "react";
import "animate.css";
import staffImg from "../../../assets/staff.png"

function StaffManagement() {
  const Instructions= [
    {
      title:"Able to schedule staff in for jobs",
    },
    {
      title:"Able to track schedule times and production rates",
    },
    {
      title:"Able to learn from production history and tackle issues straight on the line",
    },
    {
      title:"Direct line of communication between staff and management through issue reporting.",
    },
   
    
  ]
  return (
    <div className="animate__animated animate__zoomIn">
      <div className="container  w-11/12  shadow-5xl  mx-auto  px-8 py-8 my-28">
        <div className="grid grid-cols-2 gap-20 font-Montserrat">
        <div className="md:flex md:flex-col content-start  justify-items-start">
            <div>
              <img
                src={staffImg}
                alt="Logo"
                className="h-80  rounded-sm  "
              />
            </div>
          </div>
          <div className="md:flex md:flex-col content-start  justify-items-start">
            <h2 className="text-blue-200 text-2xl font-bold">
              Management of Staff
            </h2>
            {Instructions.map((item, i) => (
             <div key={i} className="list-item pt-2 ml-8">
             
             <div>{item.title}</div>
           </div>
            ))}
          </div>
          
        </div>
      </div>
    </div>
  );
}

export default StaffManagement;
